<template>
  <BaseModal
    :value="dialogState"
    :modal-title="`Supprimer la catégorie ${
      activeCategory && activeCategory.name
    } ?`"
    @close="close"
  >
    <template #modal>
      <div class="text-center">
        <div
          class="alert_danger"
          v-text="
            `Cette action ne pourra pas être
          annulée. Tous les champs assigné à cette catégorie seront désormais
          sans catégorie .`
          "
        />
      </div>
    </template>
    <template #actions>
      <BaseButton
        class="mx-2 ml-auto"
        type="secondary"
        text
        color="#707080"
        :loading="isSubmiting"
        @click="submit"
      >
        {{ $t("utils.delete") }}
      </BaseButton>
      <BaseButton color="primary" type="primary" @click="close">
        {{ $t("utils.cancel") }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
import WorkflowAPI from "@/modules/Admin/Services/workflow.api";
export default {
  name: "WorkflowRemoveStatusCategory",
  props: {
    dialogState: {
      type: Boolean,
    },
    activeCategory: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isSubmiting: false,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async submit() {
      this.isSubmiting = true;
      try {
        await WorkflowAPI.deleteWorkflowStatusCategory({
          organizationId: this.$route.params.organizationId,
          workflowId: this.$route.params.workflowId,
          statusId: this.activeCategory.statusId,
          categoryId: this.activeCategory.id,
        });
        this.$emit("categoryRemoved");
        this.$store.dispatch("snackbar/active", {
          message: "Categorie supprimer",
          type: "SUCCESS",
        });
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.isSubmiting = false;
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.alert_danger {
  padding: 0 8px;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #ff5267;
}
</style>
